import { ITongHopNamActionTypes } from "../../action-types/tong-hop-diem/ITongHopNamActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITongHopNamReducer } from "../../reducer-model/tong-hop-diem/ITongHopNamReducer";

const iniState: ITongHopNamReducer = {
    status: eReducerStatusBase.is_not_initialization,
    tongHopDiem: {
        chuongtrinhdaotaochitietlist: [],
        ketquatonghop: []
    }
}

export const TongHopNamReducer = (state: ITongHopNamReducer = iniState, action: ITongHopNamActionTypes): ITongHopNamReducer => {
    switch (action.type) {
        case "TONG_HOP_NAM_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "TONG_HOP_NAM_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tongHopDiem: action.payload
            };
        case "TONG_HOP_NAM_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "TONG_HOP_NAM_CHANGED_FOCUSED_VALUE_LOP":
            return {
                ...state,
                focusedValueLop: action.payload,
                tongHopDiem: {
                    ...state.tongHopDiem,
                    chuongtrinhdaotaochitietlist: [],
                    ketquatonghop: []
                }
            };
        default:
            return state;
    }
}